/**
 * These React components are used to indicate correct and wrong answers in the interactions
 */

import React from 'react';
import PropTypes from 'prop-types';

import interactionOutcomeUtils from '../../../qti/utils/InteractionOutcomeUtils';
import OutcomeIcon from './OutcomeIcon';

class InteractionOutcomeIndicator extends React.PureComponent {
    static propTypes = {
        answerOption: PropTypes.string, // could be a simple choice identifier or a pair from matching or dnd
        correctResponses: PropTypes.array.isRequired,
        onReady: PropTypes.func,
        outcomeIsCorrect: PropTypes.string, // provided only for text entry interactions (numeric/math/string)
        outcomeIsPartiallyCorrect: PropTypes.string,
        isAttempted: PropTypes.bool.isRequired, // indicates if the interaction has been attempted or not
        addItemToTrack: PropTypes.func,
        skipUnansweredIndicator: PropTypes.bool,
    };

    // eslint-disable-next-line camelcase,react/sort-comp
    UNSAFE_componentWillMount() {
        if (this.props.onReady !== undefined) {
            this.onReady = this.props.onReady;
        } else if (this.props.addItemToTrack !== undefined) {
            this.onReady = this.props.addItemToTrack(`${this.props.answerOption} outcomeIcon`);
        }
    }

    componentDidMount() {
        if (!this.shouldShowIcon() && this.onReady !== undefined) {
            this.onReady(true);
        }
    }

    shouldShowIcon() {
        const { answerOption, correctResponses, isAttempted, outcomeIsCorrect, skipUnansweredIndicator } = this.props;
        const isCorrect = interactionOutcomeUtils.isAnswerCorrect(
            answerOption,
            correctResponses,
            outcomeIsCorrect
        );
        return (correctResponses && !(!isCorrect && !isAttempted && skipUnansweredIndicator));
    }

    render() {
        const { answerOption, correctResponses, isAttempted, outcomeIsCorrect, outcomeIsPartiallyCorrect } = this.props;
        if (!this.shouldShowIcon()) {
            return null;
        }
        const isCorrect = interactionOutcomeUtils.isAnswerCorrect(
            answerOption,
            correctResponses,
            outcomeIsCorrect
        );
        const isPartiallyCorrect = interactionOutcomeUtils.isAnswerPartiallyCorrect(outcomeIsPartiallyCorrect);
        return (
            <OutcomeIcon
                isCorrect={isCorrect}
                isPartiallyCorrect={isPartiallyCorrect}
                isAttempted={isAttempted}
                onReady={this.onReady}
            />
        );
    }
}

export default InteractionOutcomeIndicator;
